module.exports = __webpack_public_path__ + "static/prepaidFeature1-aa5f2b0b4002824507361775cc3f5d0b.svg";